<template>
  <b-container fluid class="py-3">
    <b-row class="position-relative">
      <b-col>
        <SkeletonTableLoader :columns="headers" :loading="loading" />
        <div v-if="!loading">
          <MasterEmpty v-if="items.length === 0" eheader="Invoice Payments" econtent="Invoice Payments"
            eimg="/src/assets/Img/icons/supplier-mapping.svg" :createline="false" />
          <Tableview v-if="items.length !== 0" v-model:value="items" :paginator="true"
            class="p-datatable-gridlines inovicetable" :rows="10" :rowHover="true" filterDisplay="menu"
            :loading="loading" responsiveLayout="scroll" :columns="headers" dataKey="ID" :addnewbtn="true"
            FromPage="OutStandingInvoicesTable">

            <template v-slot:PaymentFlag="{ data }">
              <OrangeStatus name="Payment Pending" v-if="data.PaymentFlag == '2'" />
              <BlueStatus name="Partially Paid" v-if="data.PaymentFlag == '3'" />
              <GreenStatus name="Paid" v-if="data.PaymentFlag == '1'" />
            </template>
            <template v-slot:Initiate="{ data }">
              <div class="action-container" v-if="data.Initiate == true">
                <GreenStatus name="Initiated" />
              </div>
              <div class="action-container" v-if="data.Initiate == false">
                <OrangeStatus name="Not Initiated" />
              </div>
            </template>

          </Tableview>
        </div>
      </b-col>
    </b-row>
  </b-container>
  <Toast />
</template>

<script lang="ts">
import {
  defineComponent,
  ref,
  computed,
  PropType,
  watch,
  onMounted,
} from "vue";
import Tableview from "../../../../../../components/FormComponents/NormalTable.vue";
import { useRouter, useRoute } from "vue-router";
import SkeletonTableLoader from "../../../../../../components/FormComponents/SkeletonTableLoader.vue";
import MasterEmpty from "../../../../../../components/Masters/MasterEmpty.vue";
import SupplierPaymentMasterService from "../../../../../../modules/Inventory/Service/SupplierPaymentMasterService";
import CustomDatePicker from "../../../../../../components/FormComponents/DatePicker.vue";
import moment from "moment";
// import PrePaymentCreationPopup from "../../../../modules/Inventory/pages/Transaction/Payment/SupplierPayment/PrePaymentCreation.vue";
import { useToast } from "primevue/usetoast";

export default defineComponent({
  components: {
    Tableview,
    SkeletonTableLoader,
    MasterEmpty,
    CustomDatePicker,
  },
  props: {
    datas: {
      type: Array,
      default: [],
    },
    activeIndex: {
      type: Number,
      default: 0,
    },
  },
  setup(props, { emit }) {
    const activeTabIndex = ref(props.activeIndex);
    const router = useRouter();
    const route = useRoute();
    const toast = useToast();
    let SessionUserData = localStorage.getItem("UsersData");
    let usersData;
    if (SessionUserData !== null) {
      usersData = JSON.parse(SessionUserData);
    }

    let showdatefilter = ref();
    const items: any = ref([]);
    onMounted(async () => {
      IsShow();
    });
    const loading = ref(false);
    let fullPath = ref();
    let uploadId = ref();
    let uploadedTableList: any = ref([]);


    watch(
      () => props.activeIndex,
      (newVal: any) => {
        IsShow();
      },
      { deep: true }
    );

    //DataTable Fields
    const headers = [
      {
        header: "S.No",
        field: "RowNumber",
        class: "filterdisplaynone",
      },
      {
        header: "GRN Code",
        field: "DocNo",
        class: "filterdisplaynone",
        bodyclass: "boldclass",
      },
      {
        header: "PO Code",
        field: "POCode",
        class: "filterdisplaynone",
        bodyclass: "boldclass",
      },
      {
        header: "Invoice Id",
        field: "InvoiceID",
        class: "filterdisplaynone",
        bodyclass: "boldclass",
      },
      {
        header: "Invoice Date",
        field: "InvoiceDate",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "boldclass",
      },

      {
        header: "Amount",
        field: "Amount",
        class: "filterdisplaynone",
        bodyclass: "boldclass",
      },
      {
        header: "DueAmount",
        field: "DueAmount",
        class: "filterdisplaynone",
        bodyclass: "boldclass",
      },
      {
        header: "PaymentFlag",
        fieldDisplay: "false",
        slot: "PaymentFlag",
        sortable: false,
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
    ];

    async function IsShow() {
      debugger;
      try {
        const dataresponse =
          await SupplierPaymentMasterService.GetInvoicePaymentsById(
            route.query.Id,
            usersData.OrganizationId,
            usersData.BranchId,
            route.query.StoreId
          );
        let count = 0
        items.value = dataresponse["result"].map((item: any) => {
          count = count + 1;
          item.RowNumber = count;
          item.Amount = item.Amount.toFixed(2);
          item.DueAmount = item.DueAmount.toFixed(2);
          return item;

        });
        uploadedTableList.value = [];
        for (let i = 0; i < items.value.length; i++) {
          if (items.value[i]["FileUpload"]) {
            const fileUploads = items.value[i]["FileUpload"].split(",");

            fileUploads.forEach((FileUpload) => {
              const fileName = FileUpload.split("/").pop();
              if (fileName) {
                const fileEntry = {
                  uploadId: items.value[i]["POPaymentId"],
                  fileName: fileName.trim(),
                  fullPath: FileUpload.trim(),
                };
                uploadedTableList.value.push(fileEntry);
              }
            });
          }
        }
      } catch (error) {
        console.log(error);
      }
    }

    function fileviewer(data) {
      debugger;
      const newTabUrl = data;
      window.open(newTabUrl, "_blank");
    }
    return {
      uploadedTableList,
      fileviewer,
      items,
      loading,
      headers,
      IsShow,
      activeTabIndex,
      showdatefilter,
    };
  },
});
</script>

<style lang="scss" scoped>
.datepickerinvoicefield {
  max-width: 600px;
  margin-right: 15px;
  position: absolute;
}

.cleardate {
  margin-left: 15px;
  margin-top: 10px;
}
</style>
<style lang="scss">
.inovicetable .p-datatable {
  margin-top: 20px;
}

.disableclass {
  pointer-events: none;
  opacity: 0.5;
}
</style>
